import { useAuthStore } from '../../store/authStore'
import { useCreditBalance } from './useCreditBalance'
import {
  canShowUpgradeCompare,
  normalizeCompareTier,
  upgradeCreditsPath,
  type CompareTier,
} from '../../lib/upgradePlanEconomics'

export function useUpgradePlanEligibility(options?: { dismissed?: boolean }) {
  const { user } = useAuthStore()
  const { data: balance } = useCreditBalance()

  const tierCode = normalizeCompareTier(balance?.subscription?.tier_code)
  const eligible =
    !!user &&
    user.role !== 'admin' &&
    canShowUpgradeCompare(tierCode) &&
    !options?.dismissed

  return {
    show: eligible,
    tierCode,
    upgradePath: upgradeCreditsPath(tierCode) as '/credits#plans' | '/credits?plan=VIP',
    currentCompareTier: tierCode as Extract<CompareTier, 'FREE' | 'STANDARD'>,
  }
}
